import React from "react";
import { Fragment } from "react";

const Card = ({
  title,
  bgColor,
  rows = [],
  subtitleCounter,
}) => (
  <div className="card border-0">
    <div className={`card-header ${bgColor}`}>
      <div className="row">
        <div className="col-9">
          <h5 className="h3 mb-0 text-white">{title}</h5>
        </div>
        <div className="col-3 d-flex flex-row-reverse">
          <div className="badge badge-info pull-right">{subtitleCounter}</div>
        </div>
      </div>
    </div>
    <div className="card-body text-center">
      {rows.map((row, i) => {
        return (
          <Fragment key={'r-' + i}>
            <div className="row">
              {(row || []).map((col, j) => (
                <div key={'c-' + j} className="col">
                  <span className="h6 surtitle">{col['title']}</span>
                  <span className={`d-block h4 ${col['color']}`}>{col['value']}</span>
                </div>
              ))}
            </div>
            {rows.length > 1 && rows.length !== i + 1 && (
              <hr className="my-3" />
            )}
          </Fragment>
        )
      })}
    </div>
  </div>
);

export default Card;



// WEBPACK FOOTER //
// ./src/components/Pages/Orders/Header/Card.js